// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Generator-module--bx--text-truncate--end--KOTDW";
export var bxTextTruncateFront = "Generator-module--bx--text-truncate--front--2JFPq";
export var container = "Generator-module--container--PH4mL";
export var fieldBlock = "Generator-module--field-block--qHbNx";